import Axios from 'axios';
export default class HLogger {
    Fatal(exception, message) {
        var log = {
            LogLevel: "Fatal",
            Message: message,
            ExceptionMessage: exception.Message,
            ExceptionStackTrace: exception
        };
        this.sendLog(log);
    }
    Error(exception, message) {
        var log = {
            LogLevel: "Error",
            Message: message,
            ExceptionMessage: exception.Message,
            ExceptionStackTrace: exception
        };
        this.sendLog(log);
    }
    Warn(message) {
        var log = {
            LogLevel: "Warn",
            Message: message
        };
        this.sendLog(log);
    }
    Trace(message, traceLevel) {
        var log = {
            LogLevel: "Trace",
            Message: message,
            TraceLevel: traceLevel
        };
        this.sendLog(log);
    }
    sendLog(log) {
        var bodyFormData = new FormData();
        bodyFormData.append('Source', process.env.VUE_APP_LOG_SOURCE);
        bodyFormData.append('CallSite', location.href);
        bodyFormData.append('LogLevel', log.LogLevel);        
        bodyFormData.append('Message', log.Message);
        if (log.ExceptionMessage) {
            bodyFormData.append('ExceptionMessage', log.ExceptionMessage);
        }
        if (log.ExceptionStackTrace) {
            bodyFormData.append('ExceptionStackTrace', log.ExceptionStackTrace);
        }
        try {
            var user = JSON.parse(sessionStorage.getItem("GlobalAuthUser"));
            if (user) {
                bodyFormData.append('Username', user.username);
            }
        } catch (err) {
            console.error(err);
        }

        let current_datetime = new Date();
        bodyFormData.append('TimeWritten', current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes() + ":" + current_datetime.getSeconds());

        Axios.post(process.env.VUE_APP_LOG_URL, bodyFormData, {headers: {'Content-Type': 'multipart/form-data' }});
    }
}